import { data } from "./mappings-data.js";
import { keyboardLayouts } from "./keyboard-layouts.js";
export const encodings = [...data.names.filter((name) => !["aaa", "racxa"].includes(name)), "modern-mtavruli", "nuskhuri", "latin-russian", "latin-typewriter", "latin-translit"];
export const commonEncodings = ["_eng_", "_utf8_", "_standart_", "modern-mtavruli", "_utf8_UpperCase_", "nuskhuri"];
// Keep historical aliases usable by font profiles, but list each table only once.
const seenTables = new Set();
export const encodingOptions = [...commonEncodings, ...encodings].filter((name) => {
  const signature = data.tables[name] ? JSON.stringify(data.tables[name]) : name;
  if (seenTables.has(signature)) return false;
  seenTables.add(signature);
  return true;
});
function normalize(text, mode) {
  return [...text]
    .map((ch) => {
      const n = ch.codePointAt(0);
      return mode === "modern-mtavruli" && n >= 0x1c90 && n <= 0x1cbf
        ? String.fromCodePoint(n - 0xbc0)
        : mode === "nuskhuri" && n >= 0x2d00 && n <= 0x2d2f
          ? String.fromCodePoint(n - 0x1c30)
          : ch;
    })
    .join("");
}
function targetCase(text, mode) {
  return [...text]
    .map((ch) => {
      const n = ch.codePointAt(0);
      return n >= 0x10d0 && n <= 0x10ff
        ? String.fromCodePoint(
            n + (mode === "modern-mtavruli" ? 0xbc0 : 0x1c30),
          )
        : ch;
    })
    .join("");
}
export function convert(text, from, to, layout = "unchanged") {
  if (typeof text !== "string") throw new TypeError("Text must be a string");
  if (!encodings.includes(from) || !encodings.includes(to))
    throw new RangeError("Choose a supported encoding");
  if (!["unchanged", "eng-to-rus", "rus-to-eng"].includes(layout))
    throw new RangeError("Choose a supported keyboard layout");
  if(from === "latin-translit") from="Tariel_Putkaradze_Transliteration";
  if(to === "latin-translit") to="Tariel_Putkaradze_Transliteration";
  if(keyboardLayouts[from] || keyboardLayouts[to]){
    const decode=(value,map)=>{const reverse=new Map();for(const [unicode,stored] of Object.entries(map))if(!reverse.has(stored))reverse.set(stored,unicode);return [...value].map(c=>reverse.get(c)||(/^[A-Z]$/.test(c)?reverse.get(c.toLowerCase()):null)||c).join("");};
    const unicode=keyboardLayouts[from]?decode(text,keyboardLayouts[from]):convert(text,from,"_utf8_");
    return keyboardLayouts[to]?[...unicode].map(c=>keyboardLayouts[to][normalize(c,"modern-mtavruli")]||c).join(""):convert(unicode,"_utf8_",to);
  }
  const specialFrom = ["modern-mtavruli", "nuskhuri"].includes(from),
    specialTo = ["modern-mtavruli", "nuskhuri"].includes(to);
  const source = data.tables[specialFrom ? "_utf8_" : from],
    target = data.tables[specialTo ? "_utf8_" : to];
  const index = new Map();
  source.forEach((code, i) => {
    if (typeof code === "number" && !index.has(code)) index.set(code, i);
  });
  const permutation =
    layout === "eng-to-rus"
      ? data.layout1
      : layout === "rus-to-eng"
        ? data.layout2
        : null;
  const result = [...normalize(text, from)]
    .map((char) => {
      let i = index.get(char.codePointAt(0));
      if (i === undefined) return char;
      if (permutation) i = permutation[i];
      const code = target[i];
      return typeof code === "number" ? String.fromCodePoint(code) : char;
    })
    .join("");
  return specialTo ? targetCase(result, to) : result;
}
